export default {
  notifications: [],
  quotationNotifications: [],
  profiles: {},
  loading: false,
  quotationLoading: false,
  lastFetch: null,
  lastQuotationFetch: null,
  testMode: false,
}
